import React from 'react'
import Button from '../components/Button/Button'
import { Color, Direction } from '../utils/constants'
import { FormattedMessage } from 'react-intl'
import { FormattedMessageWithClass } from '../utils/helpers'
import { Link } from '../utils/helpers'
import Background from '../assets/backgrounds/notfound.svg'
import PageHeader from '../partials/PageHeader'

const NotFound = () => {
    return (
        <PageHeader bgColor={Color.SAND} component={Background} link={'/'}>
            <div className='flex flex-col items-center justify-center text-center py-24'>
                <FormattedMessage id={'page.notFound.lost'} tagName='h1' />
                <FormattedMessageWithClass
                    id={'page.notFound.404'}
                    tagName='h4'
                    className='opacity-60 mb-16'
                />
                <Button isInverted chevron={Direction.RIGHT} buttonColor={Color.PURPLE}>
                    <Link to={'/'}>
                        <FormattedMessage id={'page.notFound.goBack'} tagName='h6' />
                    </Link>
                </Button>
            </div>
        </PageHeader>
    )
}

export default NotFound
